export const fr = {
    actions: 'Actions',
    active: 'Activé',
    add: 'Ajouter',
    advancedFilters: 'Filtres avancés',
    announcements: 'Annonces',
    archive: 'Archiver',
    back: 'Retour',
    cancel: 'Annuler',
    comment: 'Commentaire',
    confirm: {
        confirmAction: 'Confirmer',
        confirmContent: 'Souhaitez-vous confirmer {action} ? {complement}',
        confirmTitle: 'Confirmer {action} de "{item}"',

        add: "l'ajout",
        archive: "l'archivage",
        archiveComplement: 'Cette action est définitive',
        delete: 'la suppression',
        deleteComplement: 'Cette action est définitive',
        edit: "l'édition"
    },
    close: 'Fermer',
    connectedAs: 'Connecté en tant que',
    create: 'Créer',
    delete: 'Supprimer',
    description: 'Description',
    details: 'Détails',
    diagnostic: 'Diagnostic',
    disabled: 'Désactivé',
    edit: 'Editer',
    editMode: 'Passer en mode édition',
    exportToCsv: 'Exporter en CSV',
    from: 'De',
    hello: 'bonjour',
    hideFilters: 'Cacher les filtres',
    modifiedBy: 'Modifié par',
    myAccount: 'Mon compte',
    next: 'Suivant',
    no: 'Non',
    noAnnouncement: 'Aucune annonce pour le moment',
    noHistory: "Aucun historique n'a été trouvé",
    noOption: 'Aucune option disponible',
    noRecord: 'Aucun résultat',
    noRole: 'Aucun rôle',
    object: 'Objet',
    or: 'ou',
    resolution: 'Résolution',
    save: 'Enregistrer',
    saveModifications: 'Enregistrer les modifications',
    scan: 'Scanner',
    search: 'Rechercher',
    send: 'Envoyer',
    showDetails: 'Voir détails',
    showFilters: 'Montrer les filtres',
    showMore: 'voir plus',
    sortBy: 'Trier par',
    theme: {
        light: 'Thème clair',
        dark: 'Thème sombre'
    },
    to: 'A',
    unassociated: 'Dissocié',
    undefined: 'Non défini',
    unknown: 'Inconnu',
    upload: 'Ajouter des fichiers',
    uploadFile: 'Ajouter un fichier',
    validate: 'Valider',
    value: 'Valeur',
    viewMore: 'Afficher plus',
    typeYourSearch: 'Tapez votre recherche...',
    yes: 'Oui'
}

export const enumFr = {
    env: {
        production: 'PROD',
        development: 'DEV',
        preproduction: 'PREPROD',
        other: 'Autre'
    },
    commandStatus: {
        toSend: 'A envoyer',
        accepted: 'Acceptée',
        running: 'En cours',
        retryLater: 'Réessayer plus tard',
        finishedOk: 'Terminé',
        finishedError: 'Terminé erreur'
    },
    keyCategory: {
        authentication: 'Authentification',
        configuration: 'Configuration',
        connectivity: 'Connectivité',
        informations: 'Informations',
        misc: 'Autres',
        rfid: 'RFID',
        specific: 'Spécifique',
        filter1: 'Filtre 1',
        filter2: 'Filtre 2'
    },
    propertyType: {
        component: 'Composant',
        config: 'Configuration'
    },
    qrcode: {
        error: {
            detectionError: "Aucun QR code n'a été détecté",
            notAllowed: "Vous devez autoriser l'accès à la caméra",
            notFound: "Il n'y a pas d'appareil photo sur ce périphérique",
            notSupported: 'Contexte sécurisé requis (HTTPS, localhost)',
            notReadable: 'La caméra est-elle déjà utilisée ?',
            overconstrained: 'Les caméras installées ne conviennent pas',
            streamApiNotSupported:
                "Cette fonctionnalité n'est pas prise en charge par ce navigateur",
            insecureContext:
                "L'accès à la caméra n'est autorisé que dans un contexte sécurisé. Utilisez HTTPS ou localhost plutôt que HTTP"
        },
        success: {
            detectionSuccess: 'Le code a bien été détecté'
        }
    },
    rdrChannels: {
        channel: 'Channel {channel}',
        no: 'Non'
    },
    status: {
        disabled: 'Désactivé',
        enabled: 'Activé'
    },
    sortBy: {
        alphabeticalAsc: 'Ordre alphabétique',
        alphabeticalDesc: 'Ordre anti-alphabétique',
        dateRecent: 'Du plus récent',
        dateOld: 'Du plus ancien'
    },
    severity: {
        medium: 'Moyenne',
        high: 'Haute'
    },
    topic: {
        information: 'Information',
        dysfunction: 'Dysfonctionnement'
    },
    status_ticket: {
        technician: 'Technicien',
        commercial: 'Commercial'
    },
    validationMessages: {
        email: "L'entrée n'est pas un email."
    }
}
